"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.analysisResultFilterSchema = exports.statusDisplayToDb = void 0;
exports.isValidOverrideStatus = isValidOverrideStatus;
const sigma_engine_shared_1 = require("@cadstrom/sigma-engine-shared");
const QueryBuilder_1 = require("../QueryBuilder");
exports.statusDisplayToDb = Object.fromEntries(Object.entries(sigma_engine_shared_1.RequirementInstanceResultStatus).map(([key, value]) => [key, value]));
function resolveStatusValue(displayValue) {
    const dbValue = exports.statusDisplayToDb[displayValue];
    if (dbValue !== undefined) {
        return dbValue;
    }
    if (Object.values(exports.statusDisplayToDb).includes(displayValue)) {
        return displayValue;
    }
    throw new Error(`Unknown status display value: "${displayValue}"`);
}
function isValidOverrideStatus(status) {
    return (status === sigma_engine_shared_1.RequirementInstanceResultStatus.Error ||
        status === sigma_engine_shared_1.RequirementInstanceResultStatus.Warning ||
        status === sigma_engine_shared_1.RequirementInstanceResultStatus.Success);
}
function buildComputedStatusWhere(operator, value) {
    if (value === undefined || value === '') {
        if (operator !== 'isEmpty' && operator !== 'isNotEmpty') {
            return {};
        }
    }
    switch (operator) {
        case 'is':
        case 'equals': {
            const dbValue = resolveStatusValue(value);
            return {
                OR: [
                    ...(isValidOverrideStatus(dbValue) ? [{ statusOverride: dbValue }] : []),
                    { AND: [{ statusOverride: null }, { status: dbValue }] },
                ],
            };
        }
        case 'not':
        case 'doesNotEqual': {
            const dbValue = resolveStatusValue(value);
            return {
                AND: [
                    ...(isValidOverrideStatus(dbValue) ? [{ statusOverride: { not: { equals: dbValue } } }] : []),
                    {
                        OR: [{ statusOverride: { not: null } }, { status: { not: { equals: dbValue } } }],
                    },
                ],
            };
        }
        case 'isAnyOf': {
            const values = (0, QueryBuilder_1.parseIsAnyOfValues)(value);
            const enumValues = values.map(resolveStatusValue).filter(Boolean);
            if (enumValues.length === 0) {
                return {};
            }
            const orConditions = enumValues.flatMap((dbValue) => [
                ...(isValidOverrideStatus(dbValue) ? [{ statusOverride: dbValue }] : []),
                { AND: [{ statusOverride: null }, { status: dbValue }] },
            ]);
            return { OR: orConditions };
        }
        default:
            return {};
    }
}
exports.analysisResultFilterSchema = (0, QueryBuilder_1.createFilterSchema)({
    fields: {
        requirementId: { options: { type: QueryBuilder_1.FieldType.String, nonNullable: true } },
        typeId: { options: { type: QueryBuilder_1.FieldType.String, nonNullable: true } },
        expected: { options: { type: QueryBuilder_1.FieldType.String, nonNullable: true } },
        actual: { options: { type: QueryBuilder_1.FieldType.String, nonNullable: true } },
        status: {
            options: {
                type: QueryBuilder_1.FieldType.String,
                values: exports.statusDisplayToDb,
            },
        },
        computedStatus: {
            options: {
                type: QueryBuilder_1.FieldType.Custom,
                buildWhere: buildComputedStatusWhere,
                buildOrderBy: (direction) => [{ statusOverride: direction }, { status: direction }],
            },
        },
        originalStatus: {
            options: {
                type: QueryBuilder_1.FieldType.String,
                column: 'status',
                values: exports.statusDisplayToDb,
            },
        },
        isReviewed: { options: { type: QueryBuilder_1.FieldType.Boolean } },
        designObject: {
            options: {
                type: QueryBuilder_1.FieldType.Relation,
                relation: 'designObjects',
                searchColumns: ['net', 'module', 'component', 'signal'],
            },
        },
    },
    ignoredFields: ['actions'],
});
//# sourceMappingURL=analysis-result-filter-schema.js.map